import Vue from 'vue';
import {API_ROOT} from '../config'

const customActions = {
  activate: {method: 'PUT', url: API_ROOT + 'customer{/id}/activate'},
  deactivate: {method: 'PUT', url: API_ROOT + 'customer{/id}/deactivate'}
};

export default Vue.resource(API_ROOT + 'customer{/id}', {}, customActions);



// WEBPACK FOOTER //
// ./client/resources/customerResource.js